import TreeOrg from './tree.vue'

/* istanbul ignore next */
TreeOrg.install = function (Vue) {
  Vue.component(TreeOrg.name, TreeOrg)
}

export default TreeOrg
